export const TUTORIAL_SPLASH_IDS = {
  trainingHint: 'training-hint',
  explorer: 'explorer',
  games: 'games',
  replay: 'replay',
  replayAutoplaySettings: 'replay-autoplay-settings',
} as const;

export type TutorialSplashId =
  (typeof TUTORIAL_SPLASH_IDS)[keyof typeof TUTORIAL_SPLASH_IDS];
